import { useTranslation } from "react-i18next";
import { Anchor } from "@mantine/core";

import {
  Footer,
  HeroBackground,
  Section,
  SectionText,
  SectionTitle,
} from "components";

const ImpressumPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroBackground background={true}>
        <Section hero={true}>
          <SectionTitle variant="light" title={t("legal_notice.title")} />
          <div style={{ whiteSpace: "pre-line" }}>
            <SectionText text={t("legal_notice.content_before")} />
            <SectionText text={t("legal_notice.register_link_label")} inline />
            <SectionText inline>
              <Anchor
                href={t("legal_notice.link")}
                target="_blank"
                rel="noopener noreferrer"
                c={"#FFF"}
              >
                {t("legal_notice.register_link_text")}
              </Anchor>
            </SectionText>
            <SectionText text={t("legal_notice.content_after")} />
          </div>
        </Section>
      </HeroBackground>
      <Footer />
    </>
  );
};

export default ImpressumPage;
